// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-end[data-v-2e76cb9e]{\r\n    text-align: end;\n}\r\n", ""]);
// Exports
module.exports = exports;
